
<ng-container [ngTemplateOutlet]="tp_progress_bar"></ng-container>

<ng-template #tp_progress_bar>
    <div class="relative overflow-hidden w-full bg-gray-200 rounded-full dark:bg-gray-700" [class]="size">
        @switch (corpType) {
            @case (enumCorpTypePb.default) {
                <div [class]="'rounded-full '+corpColor+' '+size" [style]="'width:'+corpValue+'%'"></div>
            }
            @case (enumCorpTypePb.indeterminate) {
                <div class="absolute top-0 left-0 h-full w-[30%] animate-k2000" [class]="size  + ' ' + corpColor"></div>
            }
        }
    </div>
</ng-template>